import { render, staticRenderFns } from "./HotpointWord.vue?vue&type=template&id=56ee1911&scoped=true"
import script from "./HotpointWord.vue?vue&type=script&lang=js"
export * from "./HotpointWord.vue?vue&type=script&lang=js"
import style0 from "./HotpointWord.vue?vue&type=style&index=0&id=56ee1911&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee1911",
  null
  
)

export default component.exports